import { getResourceEntity } from 'js/lib/PipelineUtils';
import { getConnectionOrVendorType, isPublicDataset, isSqlAutomation } from 'js/lib/ResourceUtils';
import { getCurrentUser } from 'js/reducers/session';
import { has, map, reduce } from 'lodash';
import { connect } from 'react-redux';
import PipelineOriginCard from './PipelineOriginCard';

const mapStateToProps = (state, ownProps) => {
  const {
    entities,
    paging: { metaInfoById },
    metrics: {
      dashboard: { data_sources },
    },
    pipelines: { branches },
  } = state;
  const { cardData, isPipelineSelected } = ownProps;
  const { flowNodes, users, orgs, vendors, projects: projectsById } = entities;
  const projectMap = projectsById;
  const currentUser = getCurrentUser(state);
  //TODO: cannot assume it is source.
  const isDataSetCard = has(cardData, 'type') && cardData.type === 'DATA_SET';
  const isSharedDataSet =
    isDataSetCard && has(cardData, 'dataSetType') && cardData.dataSetType === 'shared';
  const data = getResourceEntity(cardData, entities);
  const flowData = isPipelineSelected ? flowNodes?.[data?.flow_node_id] : null;
  const branch = branches[data.nodeKey];
  let connectionInfo = null,
    connectionOrVendorType = null;
  let errorCount = 0;

  const branchItems = map(branch && branch.items, (nodeKey) => flowNodes[nodeKey]);
  const childrenCount = reduce(
    branchItems,
    (acc, thisItem, idx) => {
      if (thisItem.type === 'DATA_SET' && thisItem.dataSetType === 'derived') {
        acc.derivedDataSetsCount += 1;
      } else if (thisItem.type === 'DATA_SINK') {
        acc.sinksCount += 1;
      }
      return acc;
    },
    {
      derivedDataSetsCount: 0,
      sinksCount: 0,
    },
  );

  if (!isDataSetCard) {
    connectionOrVendorType = getConnectionOrVendorType(data, vendors, 'source_type', 'vendor_id');

    connectionInfo =
      metaInfoById && has(metaInfoById, connectionOrVendorType)
        ? metaInfoById[connectionOrVendorType]
        : null;
    errorCount = has(data_sources, `${data.id}.errors`) ? data_sources[data.id].errors : 0;
  }

  const isPublic = isPublicDataset(data);
  const isSqlAutomationSource = !isDataSetCard && isSqlAutomation(data, vendors);
  let ownerOrg = null,
    ownerUser = null,
    sharerUser = null,
    sharerOrg = null;

  if (data?.owner_id && currentUser?.id !== data?.owner_id) {
    ownerUser = users[data.owner_id];
  }

  if (data?.org_id && currentUser?.org !== data?.org_id) {
    ownerOrg = orgs[data.org_id];
  }

  return {
    isSharedDataSet,
    rootFlowNode: flowNodes[data.flow_node_id],
    project: projectMap[data.project_id] || null,
    connectionInfo,
    connectionOrVendorType,
    isSqlAutomation: isSqlAutomationSource,
    data,
    sourceDataSetsCount: data.children ? data.children.length : 0,
    childrenCount,
    errorCount,
    isDataSetCard,
    isPublic,
    ownerUser,
    ownerOrg,
    sharerOrg,
    sharerUser,
    isPipelineSelected,
    flowData,
  };
};

export default connect(mapStateToProps)(PipelineOriginCard);
